import React from 'react';
import { useSelector } from 'react-redux';
import { Menu, Dropdown, Tooltip, Modal } from 'antd';
import useStates from '../../../queries/useRequestStatuses';
import CellText from '../CellText/CellText';
import { completedStatusId } from '../../../constants/requests.constants';

const { confirm } = Modal;

const statusOrderByName = [
  'Новая',
  'В работе',
  'Выполнена',
  'Выполнена(контроль качества)',
  'Закрыта',
  'Аннулирована',
];


const statusIds = {
  new: 1,
  inWork: 2,
  closed: 3,
  cancelled: 4,
  done: 5,
  doneCallHuman: 6,
};

const doneStatusIds = new Set([statusIds.done, statusIds.doneCallHuman]);

const filterCb =
  ({ statusId, canChange }) =>
  (status) => {
    const id = status.id;

    const additionalCheckResult = canChange
      ? !doneStatusIds.has(statusId) ||
        id === statusIds.closed ||
        id === statusIds.inWork
      : id === statusIds.inWork;

    return id !== statusId && additionalCheckResult;
  };

const getMenu = (statuses = [], statusId, onClick, canChange) => {
  const displayedStatuses = statuses
    .filter(filterCb({ statusId, canChange }))
    .sort(
      (a, b) =>
        statusOrderByName.indexOf(a.description) -
        statusOrderByName.indexOf(b.description)
    );


  return (
    <Menu onClick={onClick}>
      {displayedStatuses.map((status) => (
        <Menu.Item
          key={status.id}
          status={status}
        >
          <span>{status.description.replace(/\(/g, ' (')}</span>
        </Menu.Item>
      ))}
    </Menu>
  );
};

const RequestStatus = ({
  request = {},
  getPopupContainer = () => document.body,
  tooltipPlacement = 'top',
  onStatusChange,
  onCompletedStatusClick,
  canChange = true,
}) => {
  const { data: statuses } = useStates(
    {
      staleTime: Infinity,
    },
    true
  );

  const { userInfo } = useSelector((state) => state.authentication);

  const status = request?.status
    ? `${request.status.replace(/\(/g, ' (')}`
    : '-';

  const handleMenuClick = (val) => {
    val.domEvent.stopPropagation();

    const status = val.item.props.status;

    status.id === completedStatusId
      ? onCompletedStatusClick(request, status)
      : confirm({
          title: 'Изменить статус заявки?',
          content: (
            <div>
              Заявка: <strong>{request.id}</strong>
              <br />
              Новый статус: <strong>{status.description}</strong>
            </div>
          ),
          onOk: () => onStatusChange(request, status),
          onCancel() {},
        });
  };

  if (!userInfo.CanChangeStatus) {
    return <CellText>{status}</CellText>;
  }

  return (
    <Dropdown
      getPopupContainer={getPopupContainer}
      overlay={getMenu(statuses, request.statusId, handleMenuClick, canChange)}
      trigger={['click']}
      onClick={(e) => e.stopPropagation()}
    >
      <Tooltip
        title="Изменить статус"
        getPopupContainer={getPopupContainer}
        placement={tooltipPlacement}
      >
        <CellText style={{ cursor: 'pointer' }}>{status}</CellText>
      </Tooltip>
    </Dropdown>
  );
};

export default RequestStatus;
